export default "__VITE_ASSET__BOWf_FHh__"